export const Message = {
    SomeInvalidFields: "Some fields are invalid.",
    SomethingWrong: "Something went wrong. Please try again.",
}

export default Message;
